import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { patternForm } from 'src/app/shared/constants/constants';
@Component({
  selector: 'app-customer-registration',
  templateUrl: './customer-registration.component.html',
  styleUrls: ['./customer-registration.component.scss']
})
export class CustomerRegistrationComponent implements OnInit {
  registerForm!: FormGroup;
  mobilePattern = patternForm.mobilePattern;

  constructor(public fb: FormBuilder) {
  }

  ngOnInit() {
    
  }
register(){

}
}
